import React from 'react'
import { CircularProgress } from '@material-ui/core'
import { FuseAnimateGroup } from '@fuse'
import Loader from 'app/components/Loader'

const ExtraSection = ({ isShow, isLoading, errorComp, Component }) => {
  if (!isShow) return null
  else if (errorComp) return errorComp
  else
    return (
      <Loader
        timeout={0}
        isLoading={isLoading}
        placeholder={
          <div className="w-full flex justify-center">
            <CircularProgress className="self-center m-32" color="secondary" />
          </div>
        }
      >
        <FuseAnimateGroup
          enter={{ animation: 'fadeIn' }}
          leave={{ animation: 'fadeOut' }}
        >
          {Component}
        </FuseAnimateGroup>
      </Loader>
    )
}

export default React.memo(ExtraSection)
